import { CopyOutlined } from "@ant-design/icons";
import { Button, notification } from "antd";
import { LIFF_URI } from "common/common";
import { memo } from "react";
import { useCopyToClipboard } from "react-use";

/**
 * @param {object} props
 * @param {boolean} props.isProgram
 * @param {number} props.categoryId
 * @returns {JSX.Element}
 */
const ButtonCopyLink = ({ isProgram = false, categoryId }) => {
	const [, copyToClipboard] = useCopyToClipboard();

	const handleClick = (event) => {
		event.preventDefault();
		event.stopPropagation();

		const url = new URL(LIFF_URI);
		url.searchParams.append("category", "true");
		url.searchParams.append("categoryId", `${categoryId}`);
		url.searchParams.append("isProgram", `${isProgram}`);

		copyToClipboard(url.href);
		notification.success({
			message: "コピー成功",
			// description: "",
			duration: 1,
		});
	};

	return (
		<div className="flex justify-center pt-5">
			<Button icon={<CopyOutlined />} onClick={handleClick}>
				コピー
			</Button>
		</div>
	);
};

export default memo(ButtonCopyLink);
